import React from "react";
import PropTypes from "prop-types";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        borderRadius: 8,
        backgroundColor: theme.palette.secondary[50],
        "& ul.MuiList-root": {
            padding: theme.spacing(0)
        }
    }
}));


const BaseCard = ({children}) => {
    const classes = useStyles();

    return (
        <Box className={classes.root} >
            {children}
        </Box>      
    );
};

BaseCard.propTypes = {
    children: PropTypes.any,
};


export default BaseCard;